import {
  CHANGE_PASSWORD_BY_URL_REQUEST,
  CHANGE_PASSWORD_BY_URL_SUCCESS,
  CHANGE_PASSWORD_BY_URL_FAILURE,
  CHANGE_PASSWORD_BY_URL_RESET,
} from '../Constants/actionTypes';

const initialState = {
  loading: false,
  success: false,
  error: null,      // string | null
  expired: false,   // true if token/uid invalid/expired
};

const changePasswordByUrlReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_PASSWORD_BY_URL_REQUEST:
      return { ...state, loading: true, error: null, success: false, expired: false };
    case CHANGE_PASSWORD_BY_URL_SUCCESS:
      return { ...state, loading: false, success: true, error: null, expired: false };
    case CHANGE_PASSWORD_BY_URL_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload?.message || null,
        expired: !!action.payload?.expired,
      };
    case CHANGE_PASSWORD_BY_URL_RESET:
      return initialState;
    default:
      return state;
  }
};

export default changePasswordByUrlReducer;